import ApiClient from './ApiClient';
import hubChangelogsResponse from 'mocked/hub_changelogs_response.json';

class ChangelogApi extends ApiClient {
  constructor() {
    super('changelog', { apiVersion: 'v1' });
  }

  // eslint-disable-next-line class-methods-use-this
  fetchFromHub() {
    return Promise.resolve({ data: hubChangelogsResponse });
  }
}

export default new ChangelogApi();
